import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import _ from 'underscore';
import { Page, Header } from 'components';
import { TopOffendersWorstRegionForm } from './components';
import { SetFormState } from '../actions/WorstSitesRegionActions';

const useStyles = makeStyles(theme => ({
	root: {
		padding: theme.spacing(3)
	},
	container: {
		marginTop: theme.spacing(3)
	},
	sitelist: {
		marginTop: theme.spacing(6)
	}
}));

const WorstSitesRegionExport = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector(state => state.WorstSitesRegionReducer.formState);

	useEffect(() => {
		setFormState({
			...formState,
			values: {
				...formState.values,
				region: '',
				startDate: null,
				endDate: null,
				topSites: '10',
			},
			touched: {
				...formState.touched,
				site: false
			}
		});
	}, []);

	return (
		<Page className={classes.root} title="Top Offenders">
			<Header module="Top Offenders" view="Region Worst Sites (Impacted and Sorted)" />
			<TopOffendersWorstRegionForm />
		</Page>
	);
};

export default WorstSitesRegionExport;
